import { render, staticRenderFns } from "./PotBlock.vue?vue&type=template&id=f19022e2"
import script from "./PotBlock.vue?vue&type=script&lang=js"
export * from "./PotBlock.vue?vue&type=script&lang=js"
import style0 from "./PotBlock.vue?vue&type=style&index=0&id=f19022e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports